const buildinfo = {
  "commit": "2a21717d23892de76dfdb91898bac47b41a4c652",
  "branch": "prod",
  "date": "2022-05-30T15:15:05Z"
}
if (typeof module !== 'undefined'  && module && module.exports) { 
  module.exports.buildinfo = buildinfo  
}
